import script from "./ShowsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowsTable.vue?vue&type=script&setup=true&lang=js"

import "./ShowsTable.vue?vue&type=style&index=0&id=1fc9eefc&lang=css"

const __exports__ = script;

export default __exports__